// extracted by mini-css-extract-plugin
module.exports = {"cellCenter":"Table_cellCenter__fpWBW"};